import React, {useContext, useEffect, useState} from "react";
import {Button, FormControl} from "react-bootstrap";
import CardItemContext from "../../../../context/CardItem/CardItemContext";
import "./Basket.scss";
import {AiOutlineClose} from "react-icons/ai";

const GiftCode = () => {
    const {giftCode, activeStep, checkGiftCode, setGiftCode} =
        useContext(CardItemContext);
    const [activeGiftCode, setActiveGiftCode] = useState("");
    // const [titleGiftCode, setTitleGiftCode] = useState("");
//  cons
    // const activeGiftCode = 0;
    // console.log(activeGiftCode);
    // console.log(giftCode);
    // console.log(activeStep);
    return (
        <>
            {activeStep === 2 && (
                giftCode.title == "" ? (
                    <div className="d-flex flex-row col-6 justify-content-around align-self-center mr-t-10">
                        {/* <div className="d-flex flex-row  flex-lg-row align-items-lg-center  my-1"> */}
                        <span className="col-auto font-12-600 mr-t-4 mr-ul-t-6 mr-lg-t-2">کد تخفیف : </span>
                        <div className=" col-sm-6">
                            <FormControl
                                style={{direction: "rtl"}}
                                className=" font-10-400 shadow-none he-26 mr-r-2 "
                                type="text"
                                onChange={e => {
                                    setActiveGiftCode(e.target.value)
                                }}
                            />
                        </div>
                        <Button variant="primary" type="submit" style={{backgroundColor: "#4661ee"}}
                                className="pd-x-4 pd-y-2 font-10-600 mr-x-6"
                                onClick={e => checkGiftCode(activeGiftCode)}
                        >
                            اعمال
                        </Button>
                        {/* </div> */}
                    </div>
                ) : (
                    <div className="d-flex flex-row col-auto bg-danger bg-opacity-10 align-self-center mr-t-10 pd-x-8 pd-y-4 rd-4"
                         style={{color: "var(--rd-01)"}}>

                        <AiOutlineClose
                            className="pointer wh-16 mr-l-6 pd-2 text-center align-items-center bg-danger bg-opacity-25 rounded-circle my-auto"
                            onClick={
                                (e) => {
                                    setActiveGiftCode(0);
                                    setGiftCode({title: "", value: -1})
                                }
                            }
                        />

                        <div className="col-auto font-12-400 pd-x-0">
                          {giftCode.title}
                        </div>
                    </div>
                )
            )}
        </>
    )
}
export default GiftCode;